<template>
  <div class="content">
    <div class="search-area">
      <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
      <div class="import-a-sty">
        <!-- <a @click="toLink('/importOfSalesFlow')">销售流向导入</a><label> | </label> -->
        <a class="fontC-4fa1a4" @click="toLink('/importTerminal')">药店导入</a> <label> | </label>
        <a @click="toLink('/importCommercialCompany')">商业公司导入</a> <label> | </label>
        <a @click="toLink('/importHospital')">医院导入</a> 
        <!-- <label> | </label>
        <a @click="toLink('/importDoctor')">客户联系人导入</a>  -->
        <!-- <a @click="toLink('/importMeeting')">学术活动计划导入</a> -->
      </div>
    </div>
    <div class="search-area mt15">
      <div class="import-sty">
        <el-steps :active="active" align-center>
          <el-step title="上传文件"></el-step>
          <el-step title="确认数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <div v-if="active == 0">
          <div class="import-box ml71 mt50">
            <div class="import-box-list">
              <div class="import-box-label"><span style="color: red">*</span>导入企业：</div>
              <el-select v-model="tenantGuid" placeholder="请选择" filterable style="width: 300px" @change="tenantChange">
                <el-option
                  v-for="item in tenantList"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="import-box-list">
              <div class="import-box-label">下载模板：</div>
              <el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button>
            </div>
            <div class="import-box-list">
              <div class="import-box-label">导入文件：</div>
              <div class="upload-btn-box">
                <el-upload
                  v-if="tenantGuid"
                  class="upload-demo fl"
                  action="#"
                  :before-upload="beforeUpload"
                  multiple
                  :limit="1"
                  accept=".xlsx,.xsl,.xls,.xlsm"
                  :auto-upload="false"
                  :on-change="changeFile"
                  :on-exceed="handleExceed"
                >
                  <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading"
                    >点击上传文件</el-button
                  >
                </el-upload>
                <el-button v-else size="medium" type="info" style="width: 126px" @click="getUploadTip()"
                  >点击上传文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  当前仅支持 excel 格式文件（大小在5M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br />
                  必须严格按照模板内容填入数据，否则可能会出现导入异常
                </div>
              </div>
            </div>
          </div>
          <div class="mt15 t-right">
            <!-- <el-button size="medium" plain @click="add(1, '')">取消</el-button> -->
            <el-button size="medium" type="info" @click="next()">下一步</el-button>
          </div>
        </div>
      </div>
      <div v-if="active == 1" class="mt15">
        <div class="summary-sty">
          预计导入<b class="fontC-4fa1a4"> {{ totalRows }} </b>条数据，其中<b class="fontC-4fa1a4"> {{ errorRows }} </b
          >条可能有误，请调整后再导入
          <a class="txt-color-blue ml10" @click="getDataAll()">全部数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagY()">只看错误数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagN()">只看准确数据</a>
          <div style="float: right;padding-right: 10px;">
            <a class="txt-color-blue" @click="exportError()">下载错误数据 | </a>
            <a class="txt-color-blue" @click="deletes('',2)">批量删除</a>
          </div>
        </div>
        <el-table :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange" row-key="guid">
          <el-table-column type="selection" :reserve-selection="true" width="60" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="药店编码" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="colN"
            label="药店类型"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.colN" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="药店名称" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colC" label="连锁总部" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.colC"
                filterable
                remote
                :remote-method="getChainHeadquartes"
                placeholder="请选择"
                allow-create
              >
                <el-option
                  v-for="item in chainHeadquartesOption"
                  :key="item.customerName"
                  :label="item.customerName"
                  :value="item.customerName"
                >
                </el-option>
              </el-select>
              <!-- <el-input v-model="scope.row.colC" placeholder="请输入内容"></el-input> -->
            </template>
          </el-table-column>
          <!-- 新增-客户等级 -->
          <el-table-column prop="colD" label="客户等级" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colD" placeholder="请选择"  filterable>
                <el-option v-for="item in levelOption" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- 新增-备案名称 -->
          <el-table-column prop="colE" label="备案名称" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colE" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" label="直营门店数量" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.colF" placeholder="请输入内容"></el-input> -->
              <el-input-number v-model="scope.row.colF" :min="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="colG" label="直营门店数量" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.colG" placeholder="请输入内容"></el-input> -->
              <el-input-number v-model="scope.row.colG" :min="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="colH" label="省" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colH" placeholder="请选择" @change="province(scope.row.colH)" filterable>
                <el-option v-for="item in provinceList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colI" label="市" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colI" placeholder="请选择" @change="city(scope.row.colI)">
                <el-option v-for="item in cityList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colJ" label="区/县" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colJ" placeholder="请选择">
                <el-option v-for="item in districtList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="colK"
            label="详细地址"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="colL"
            label="药店联系人"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.colL" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="colM"
            label="药店联系电话"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.colM" placeholder="请选择">
                <el-option v-for="item in terminalList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="colO"
            label="指派人手机号"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.colO" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="colP"
            label="业务指派人员"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.colP" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="colQ"
            label="建档时间"
            header-align="center"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.colQ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorInfo"
            label="错误信息"
            header-align="center"
            align="center"
            fixed="right"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.errorInfo | errorInfo }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid,1)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pt pb back-color-fff"
          style="padding: 16px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
        <div class="mt15 t-right">
          <el-button size="medium" plain @click="active = 0">取消</el-button>
          <el-button size="medium" type="info" @click="nextImport()" v-loading.fullscreen.lock="fullscreenLoading"
            >导入</el-button
          >
        </div>
      </div>

      <div class="font-S16 mt50 h150" v-if="active >= 2">
        <img width="64" height="64" src="../../assets/images/right.png" /><br /><br />
        导入成功，本次共导入<b class="fontC-4fa1a4">{{ importSum }}</b
        >条数据
      </div>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      url: `/${serverConfig.msCommonAdminCloudService}/excel/import/custom-info?tenantGuid=`,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0002',
        errorFlag: '',
        tenantGuid:''
      },
      terminalList: [
        {
          value: '单体药店',
          label: '单体药店',
        },
        {
          value: '连锁总部',
          label: '连锁总部',
        },
        {
          value: '连锁门店',
          label: '连锁门店',
        },
        {
          value: '诊所',
          label: '诊所',
        },
        {
          value: '乡镇卫生院（含村卫生室）',
          label: '乡镇卫生院（含村卫生室）',
        },
      ],
      importSum: 0,
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      guids: [],
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      tenantGuid: '',
      tenantList: [],
      multipleSelection:[],
      levelOption:[],
      chainHeadquartesOption:[]//连锁总部
    };
  },
  created() {
    // this.src = '';
    // this.getSrc();
    this.getChainHeadquartes();
    this.getTenantOperationRelList();
  },
  watch: {},
  mounted() {},
  methods: {
    //获取连锁总部
    getChainHeadquartes(val) {
      let query = {
        pageIndex: 1,
        tenantGuid: this.tenantGuid,
        pageSize: 30,
        keyword: val,
        customerType: '5'
      };
      this.api.postJson(`/${serverConfig.msCustomerService}/customer/get-customer-es`, query).then((res) => {
        if (res.data.msg == 'success') {
          this.chainHeadquartesOption = res.data.data.records || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    tenantChange(val){
      this.api.get(
        `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${val}&code=KHDJ`
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = resp.data.data;
          let customerNewArr = [];
          if(list&&list.length>0){
            list.forEach(item=>{
              customerNewArr.push({
                label:item.name,
                value:item.parameterValue
              })
            })
          }
          this.levelOption = customerNewArr;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    toLink(link) {
      this.$router.push({ path: link });
    },
    province(pr) {
      let self = this;
      self.cityList = [];
      self.provinceList.forEach(function (i) {
        if (i.label == pr) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.cityList.push(j);
            });
          }
        }
      });
    },
    city(ci) {
      let self = this;
      console.log(self.cityList);
      self.districtList = [];
      self.cityList.forEach(function (i) {
        if (i.label == ci) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.districtList.push(j);
            });
          }
        }
      });
    },
    getUploadTip() {
      this.$message.error('请先选择导入企业');
    },
    //获取公司下拉
    getTenantOperationRelList(flg) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data || [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    uploadExcel() {
      window.open('/终端资料_导入模版.xlsx');
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let formData = new FormData();
        formData.append('file', file.raw); //传文件
        self.api.postFile(self.url + this.tenantGuid, formData).then(function (res) {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: 'success',
              message: '上传成功',
            });
          } else {
            self.$message({
              type: 'warning',
              message: '数据格式不正确！',
            });
            return false;
          }
        });
      }
    },
    next() {
      let self = this;
      self.active = 1;
      self.getData(true);
    },
    getDataAll() {
      let self = this;
      self.page.errorFlag = '';
      self.getData(true);
    },
    getDataErrorFlagY() {
      let self = this;
      self.page.errorFlag = 'Y';
      self.getData(true);
    },
    getDataErrorFlagN() {
      let self = this;
      self.page.errorFlag = 'N';
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.page.tenantGuid = self.tenantGuid;
      self.api
        .postJson(`/${serverConfig.msCustomerService}/import-data/get-import-intermediate-data`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.details.records;
            self.errorRows = res.data.data.errorRows;
            self.totalRows = res.data.data.totalRows;
            self.page.totalPage = res.data.data.details.totalPages;
            self.page.totalRows = res.data.data.details.totalRows;
            self.loading = false;
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
    },
    save(row) {
      let self = this;
      // row.colA = self.$moment(row.colA).format('YYYY-MM-DD HH:mm:ss');
      if (row.colF == '市辖区' || row.colF == '县') {
        row.colF = row.colE;
      }
      row.errorFlag = 'N';
      row.errorInfo = '';
      self.loading = true;
      self.api.put(`/${serverConfig.msCustomerService}/import-data/update-intermediate-data`, row).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('保存成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    deletes(guid,type) {
      let self = this;
      if(type !== 1&&!self.multipleSelection.length){
        self.$message.error('请勾选数据');
        return
      }
      self.guids = [];
      if(type == 1){
        self.guids = [guid];
      }else{
        self.guids = self.multipleSelection;
      }
      self.loading = true;
      self
      .$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        self.api
        .postJson(`/${serverConfig.msCustomerService}/import-data/delete-intermediate-data`, self.guids)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
      });
      
    },
    nextImport() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msCustomerService}/import-data/finish-customer?tenantGuid=` + this.tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.importSum = res.data.data;
            self.$message.success('导入成功');
            self.active = 3;
            self.fullscreenLoading = false;
          } else {
            self.active = 1;
            self.fullscreenLoading = false;
            self.$message.error(res.data.msg);
            self.getData(true);
          }
        });
    },
    //导出错误信息
    exportError(){
      this.api.get(`/${serverConfig.msCustomerService}/import-data/get-customer-error-data?tenantGuid=${localStorage.guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas || [], res.data.data.sheetName, res.data.data.fileNam, res.data.data.dataComments||[]);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //公共导出
    reportJx(colNames, datas, sheetName, fileNam,dataComments) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
          dataComments:dataComments
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getData(false);
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    
    }, 
  },
};
</script>
<style  scoped>
.importList /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4 !important;
  border-color: inherit;
}
.importList /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
.importList /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.importList /deep/ .el-step__title.is-finish {
  color: #4fa1a4;
  font-weight: bold;
}
.import-box-list {
  display: flex;
  margin-bottom: 15px;
}
.import-box-label {
  width: 110px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
}
.upload-btn-box {
  display: flex;
  flex-direction: column;
}
</style>